import { render, staticRenderFns } from "./modalRejectApprovalMPR.vue?vue&type=template&id=2ebc3ea8&scoped=true"
import script from "./modalRejectApprovalMPR.vue?vue&type=script&lang=js"
export * from "./modalRejectApprovalMPR.vue?vue&type=script&lang=js"
import style0 from "./modalRejectApprovalMPR.vue?vue&type=style&index=0&id=2ebc3ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebc3ea8",
  null
  
)

export default component.exports